import React from 'react'
import NavBar from '../components/NavBar';
import AboutContent from '../components/AboutContent';
import Contact from '../components/Contact';

const About = () => {
  return (
    <div>
        <NavBar />
        <AboutContent />
        <Contact />
    </div>
  )
}

export default About;